export default "__VITE_ASSET__CO_xmy4X__"